/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Badge_DraftInputs */

const vi_einvoice_badge_draft = /** @type {(inputs: Einvoice_Badge_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa gửi MISA`)
};

/**

* @param {Einvoice_Badge_DraftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_badge_draft = /** @type {((inputs?: Einvoice_Badge_DraftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Badge_DraftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_badge_draft(inputs)
});